import React from 'react';
import { Grid } from '@material-ui/core';
// import { Link } from 'react-router-dom';
import Page from '../../layout/components/PageAuth.jsx';
// import LoginForm from './forms/LoginForm';
import LogoColor from '../../assets/images/logo-master-color.png';
// import Footer from '../../layout/components/FooterAuth';
import RightContent from './common/ContentRightSignupAmz';
import LoginOptionAmz from './common/LoginOptionAmz';
// import { _route } from '../../utils/sg.js';
import free from '../../assets/icons/amz-free.svg';
// import ads from '../../assets/icons/amz-expert.svg';
// import human from '../../assets/icons/amz-human.svg';
// import clock from '../../assets/icons/amz-clock.svg';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { useSelector } from 'react-redux';

function Login() {
  const today = new Date();
  const { org } = useSelector(({ auth }) => auth);

  return (
    <Page title="Login">
      <Grid container className="auth_viewAmz">
        <Grid item lg={12} md={12} sm={12} xs={12} className="auth_view_contentAmz customScrollbarAmz">
          <div className="signup_holderAmz">
            <div className="web_show">
              <a className="logo_reg" href="/">
                <img src={LogoColor} alt="Logo" className="logo_authAmz" />
              </a>
            </div>
            {/* <div className="signin_link web_show">
              Don't have an account?
              <Link to={_route('register')} className="login_acc_link">
                Create
              </Link>
            </div> */}
          </div>
          <div className="mob_show">
            <div>
              <a className="logo_reg" href="/">
                <img src={LogoColor} alt="Logo" className="logo_auth" />
              </a>
            </div>
          </div>
          <div className="form_main_content" style={{ padding: '0 2em' }}>
            <div className="signup_form_holder_amz">
              <div className="title_reg_right_amz">
                Welcome to SellerGeni <span className="waveHand">👋</span>
              </div>
              <div className="subtitle_reg_right_amz_holder">
                <p className="subtitle_reg_right_amz">
                  Thank you for choosing SellerGeni's 2-months free tool as part of the Elevate Program. Please read the
                  program information below.
                </p>
              </div>

              {/* <div className="sigin_link_mob mob_show">
                Don't have an account?
                <Link to={_route('register')} className="login_acc_link">
                  Create Account
                </Link>
              </div> */}
              {/* <LoginForm /> */}

              <LoginOptionAmz />
              <div className="footer_tc_text">
                By registering, you agree to SellerGeni's&nbsp;
                <a
                  underline="always"
                  color="text.primary"
                  href="https://sellergeni.com/terms-and-privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  T&C.
                </a>
              </div>
              <div className="slogan-sm-offer-holder-amz">
                <div className="slogan-sm-offer-amz">
                  <div className="slogan-sm-offer-single-amz" style={{ color: '#344054', paddingRight: '20px' }}>
                    <div>
                      <img src={free} />
                    </div>
                    <div>2 months FREE Ads Management service.</div>
                  </div>
                  <div className="slogan-sm-offer-single-amz" style={{ color: '#344054', paddingRight: '20px' }}>
                    <div>
                      <CheckCircleOutlineRoundedIcon />
                    </div>
                    <div>Verified as Amazon Partner.</div>
                  </div>
                </div>
                {/* <div className="slogan-sm-offer-amz slogan-sm-offer-amzRight">
                  <div className="slogan-sm-offer-single-amz" style={{ color: '#344054' }}>
                    <div>
                      <img src={human} />
                    </div>
                    <div> Account Manager Support.</div>
                  </div>
                  <div className="slogan-sm-offer-single-amz" style={{ color: '#344054' }}>
                    <div>
                      <img src={clock} />
                    </div>
                    <div>Save 90% time with automation.</div>
                  </div>
                </div> */}
              </div>

              {/* service included */}
              <div className="signup_holder_amz_servicelist_holder">
                <div style={{ height: '2px', background: 'rgb(0 0 0 / 8%)' }}></div>
                <div className="signup_holder_amz_list_box">
                  <div style={{ fontSize: '18px', fontWeight: '500', textAlign: 'left' }}>
                    Services included in this program
                  </div>
                  <div>
                    <ul className="signup_holder_amz_servicelist">
                      <li>
                        <span>Ads Management :</span> Launching new campaigns, Optimising existing campaigns through real
                        time AI based bidding.
                      </li>
                      <li>
                        <span>Budget Planning & Automation :</span> Data driven budget planning and updates. Never run out of
                        budgets on your performing campaigns.
                      </li>
                      <li>
                        <span>Keywords Management :</span> Analyse your keywords, search terms & targets to recommend
                        keywords & remove negative keywords.
                      </li>
                      <li>
                        <span>Weekly Automated Reports :</span> Get access to reports weekly and access to dashboard.
                      </li>
                      <li>
                        <span>Bi-Weekly meeting :</span> Once in 2 weeks you get a dedicated 30mins call with your account
                        manager.
                      </li>
                      <li style={{ paddingBottom: '0' }}>
                        <span>Free access to AI Tool :</span> Get complete access to SellerGeni AI tool to automate your
                        campaigns and grow your business.
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="signup_holder_amz_notlist_holder">
                  <div className="signup_holder_amz_notlist_holderLeft">
                    <WarningAmberRoundedIcon />
                  </div>
                  <div className="signup_holder_amz_notlist_holderright">
                    <div style={{ fontSize: '18px', fontWeight: '500', textAlign: 'left', color: '#B54708' }}>
                      Services not included in this program
                    </div>
                    <ul className="signup_holder_amz_notservicelist">
                      <li>
                        Catalogue related activities - We do not cover catalogue management, SEO, inventory management, order
                        management and any other seller central activities.
                      </li>
                      <li>Calls or whatsapp with AMs outside of the planned meetings.</li>
                      <li>Brand approval, registration etc.</li>
                      <li>Case creation, ASIN blocked, Buy-box and payment related issues.</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* service not included */}
            </div>
          </div>
        </Grid>

        <RightContent />
        <Grid
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            background: '#f7f2ff',
            padding: '2em 0',
          }}
        >
          {' '}
          {/* <Footer /> */}
          By creating an account on SellerGeni, you confirm that you agree with our&nbsp;
          <a
            underline="always"
            color="text.primary"
            href="https://sellergeni.com/terms-and-privacy"
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: 'contents' }}
          >
            Terms & Privacy Policy
          </a>
          &nbsp;
          {today.getFullYear()} {org?.name}, All Rights Reserved.
        </Grid>
      </Grid>
    </Page>
  );
}

export default Login;
